import {
    Reducer,
    useCallback,
    useReducer,
    // , ChangeEvent
} from 'react'

export type SelectState = {
    value: string | null
    open: boolean
    // search: string
}

type Action =
    | {
          type: 'value_select'
          payload: {
              value: string
          }
      }
    // | {
    //       type: 'search_change'
    //       payload: {
    //           search: string
    //       }
    //   }
    | { type: 'open' }
    | {
          type: 'close'
      }

const searchReducer: Reducer<SelectState, Action> = (state, action) => {
    switch (action.type) {
        // case 'search_change': {
        //     // const newSearchTrimmed = action.payload.search.trimStart()
        //     const { search } = action.payload
        //     return {
        //         ...state,
        //         search,
        //     }
        // }

        case 'value_select': {
            const { value } = action.payload
            return {
                ...state,
                value,
                open: false,
            }
        }

        case 'close': {
            return {
                ...state,
                // search: '',
                open: false,
            }
        }

        case 'open': {
            return {
                ...state,
                // search: '',
                open: true,
            }
        }
    }
}

export const useKktuSelectState = ({
    initialValue,
    onTouched,
}: {
    initialValue: string | null
    onTouched?: () => void
}) => {
    const [state, dispatch] = useReducer(searchReducer, {
        open: false,
        value: initialValue,
        // search: '',
    })

    return {
        state,
        onSelect: useCallback(
            (value: string) => {
                dispatch({
                    type: 'value_select',
                    payload: {
                        value,
                    },
                })
                if (onTouched) onTouched()
            },
            [onTouched]
        ),

        onOpenChange: useCallback(
            (v: boolean) => {
                dispatch(
                    v
                        ? { type: 'open' }
                        : {
                              type: 'close',
                          }
                )
                if (onTouched) onTouched()
            },
            [onTouched]
        ),

        // onChangeSearch: useCallback(
        //     (evt: ChangeEvent<HTMLInputElement>) =>
        //         dispatch({
        //             type: 'search_change',
        //             payload: {
        //                 search: evt.target.value,
        //             },
        //         }),
        //     []
        // ),
    }
}
export type UseKktuSelectState = ReturnType<typeof useKktuSelectState>
